import { useCallback } from "react";

import { getStencilById, sliceItemUpdate } from "../../utils";
import { UpdateFrameStencils } from "./use-update-frame-stencils";

export interface UpdateStencilColorProps {
  id: string;
  color: string;
  skipSave: boolean;
}

export type UpdateStencilColorFunc = (props: UpdateStencilColorProps) => void;

export const useUpdateStencilColor = (updateFrameStencils: UpdateFrameStencils): UpdateStencilColorFunc => {
  return useCallback(
    ({ id, color, skipSave }: UpdateStencilColorProps) => {
      updateFrameStencils((prevState) => {
        const { stencil } = getStencilById({ stencils: prevState || [], id });
        if (!stencil) return prevState;
        // replace the stencil with the new one
        return sliceItemUpdate({ item: { ...stencil, color }, arr: prevState });
      }, skipSave);
    },
    [updateFrameStencils]
  );
};
